import { NumberValue, VALUE_TYPE } from "Components/NumberValue";

import React from "react";
import { useButtonTexts } from "Store/texts/hooks";

interface Props {
  value: string;
  id?: string;
}

export type Deductible = number | string;

export function deductibleFrom(
  code: string,
  applicableTerms: any,
  lang: string,
): Deductible {
  const parsedValue = parseInt(code, 10);
  if (isNaN(parsedValue)) {
    return applicableTerms[lang];
  }
  return parsedValue;
}

export const DeductibleValue = ({ value, id }: Props): React.ReactElement => {
  const [{ applicableTerms }, lang] = useButtonTexts();
  const deductible = deductibleFrom(value, applicableTerms, lang);
  if (typeof deductible === "number") {
    return <NumberValue value={deductible} type={VALUE_TYPE.NOK} id={id} />;
  }
  return <span>{deductible}</span>;
};
